<template>
  <div>
    <FontAwesomeIcon :icon="faLock" class="mr-1" />
    <span class="font-medium">Want to protect your payment?</span>
    <p>
      <template v-if="listingIs.owner">
        Upgrade to include secure payment handling, verified buyers and full payment protection.
        <UtilTextLink class="underline text-brand" @click="openPaymentProtection('seller')">
          Learn more
        </UtilTextLink>
      </template>
      <template v-else>
        Upgrade to include buyer payment protection
        <UtilTextLink class="underline text-brand" @click="openPaymentProtection('buyer')">
          Learn more
        </UtilTextLink>
      </template>
    </p>
  </div>
</template>

<script>
import { faLock } from '@fortawesome/pro-regular-svg-icons'
import UtilTextLink from '@/components/utils/UtilTextLink'

export default {
  name: 'UtilPaymentProtectionLink',

  components: {
    UtilTextLink
  },

  data() {
    return {
      faLock
    }
  },

  props: {
    listing: {
      type: Object,
      required: true
    },
    listingIs: {
      type: Object,
      required: true
    }
  },

  methods: {
    openPaymentProtection(direction) {
      this.$modal.open('ModalPaymentProtection', {
        listing: this.listing,
        listingIs: this.listingIs
      })

      this.$analytics.addEvent({
        category: 'auctions',
        action: 'Clicked payment protection learn more',
        label: direction,
        value: (this.listing.price?.price || 1) * (this.listing.quantity || 1)
      })
    }
  }
}
</script>
